/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Box,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import kbankLogo from '../assets/images/kbanklogo.png';
import ktbLogo from '../assets/images/ktblogo.png';
import gsbLogo from '../assets/images/gsblogo.png';
import ttbLogo from '../assets/images/ttblogo.png';
import bayLogo from '../assets/images/baylogo.png';
import bblLogo from '../assets/images/bbllogo.png';
import scbLogo from '../assets/images/scblogo.png';
import cimbtLogo from '../assets/images/cimbtlogo.png';
import uobtLogo from '../assets/images/uobtlogo.png';
import baacLogo from '../assets/images/baaclogo.png';

const BankAccountPopup = ({
  open,
  onClose,
  onSave,
  initialBank,
  initialAccountName,
  initialAccountNumber,
}) => {
  // Set initial state as empty values or from props
  const [bank, setBank] = useState(initialBank || '');
  const [accountName, setAccountName] = useState(initialAccountName || '');
  const [accountNumber, setAccountNumber] = useState(
    initialAccountNumber || '',
  );
  const [errors, setErrors] = useState({
    bank: false,
    accountName: false,
    accountNumber: false,
  });

  useEffect(() => {
    if (open) {
      // Reset the form fields to initial values when the dialog is opened
      setBank(initialBank || '');
      setAccountName(initialAccountName || '');
      setAccountNumber(initialAccountNumber || '');
      setErrors({ bank: false, accountName: false, accountNumber: false });
    }
  }, [open, initialBank, initialAccountName, initialAccountNumber]);

  const bankOptions = [
    { label: 'ธนาคารกสิกรไทย', value: 'KBANK', icon: kbankLogo },
    { label: 'ธนาคารกรุงไทย', value: 'KTB', icon: ktbLogo },
    { label: 'ธนาคารออมสิน', value: 'GSB', icon: gsbLogo },
    { label: 'ธนาคารทหารไทยธนชาต', value: 'TTB', icon: ttbLogo },
    { label: 'ธนาคารกรุงศรีอยุธยา', value: 'BAY', icon: bayLogo },
    { label: 'ธนาคารกรุงเทพ', value: 'BBL', icon: bblLogo },
    { label: 'ธนาคารไทยพาณิชย์', value: 'SCB', icon: scbLogo },
    { label: 'ธนาคารซีไอเอ็มบีไทย', value: 'CIMBT', icon: cimbtLogo },
    { label: 'ธนาคารยูโอบี', value: 'UOBT', icon: uobtLogo },
    {
      label: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
      value: 'BAAC',
      icon: baacLogo,
    },
  ];

  const handleBankChange = (event) => {
    setBank(event.target.value);
    setAccountNumber('');
  };

  const handleAccountNameChange = (event) => {
    const value = event.target.value;
    if (value.length <= 255) {
      setAccountName(value);
    }
  };

  const handleAccountNumberChange = (event) => {
    const value = event.target.value;
    let maxLength = 10;

    if (bank === 'GSB') maxLength = 12;
    else if (bank === 'BAAC') maxLength = 13;

    if (/^\d*$/.test(value)) {
      setAccountNumber(value.slice(0, maxLength));
    }
  };

  const handleSave = () => {
    let hasError = false;
    const newErrors = { bank: false, accountName: false, accountNumber: false };

    if (!bank) {
      newErrors.bank = true;
      hasError = true;
    }

    if (!accountName) {
      newErrors.accountName = true;
      hasError = true;
    } else if (accountName.length > 50) {
      newErrors.accountName = true;
      hasError = true;
    }

    if (!accountNumber) {
      newErrors.accountNumber = true;
      hasError = true;
    }

    setErrors(newErrors);

    if (!hasError) {
      onSave({
        bank,
        accountName,
        accountNumber,
      });
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '100%',
          maxWidth: '550px',
        },
      }}
    >
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginTop: '20px',
          }}
        >
          ข้อมูลบัญชีธนาคาร
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            marginRight: '10px',
            marginLeft: '10px',
            marginTop: '6px',
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth error={errors.bank} size="small">
                <InputLabel>เลือกธนาคาร</InputLabel>
                <Select
                  value={bank}
                  onChange={handleBankChange}
                  label="เลือกธนาคาร"
                  size="small"
                  renderValue={(selected) => {
                    const selectedBank = bankOptions.find(
                      (option) => option.value === selected,
                    );
                    return (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <img
                          src={selectedBank.icon}
                          alt={selectedBank.label}
                          style={{
                            width: 20,
                            height: 20,
                            marginRight: 8,
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                        />
                        {selectedBank.label}
                      </Box>
                    );
                  }}
                >
                  {bankOptions.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          marginRight: '10px',
                        }}
                      >
                        <img
                          src={option.icon}
                          alt={option.label}
                          style={{
                            width: 20,
                            height: 20,
                            marginRight: 8,
                            borderRadius: '50%',
                            objectFit: 'cover',
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={option.label} sx={{ margin: 0 }} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="ชื่อบัญชี"
                value={accountName}
                onChange={handleAccountNameChange}
                fullWidth
                error={errors.accountName}
                helperText={errors.accountName ? 'กรุณากรอกชื่อบัญชี' : ''}
                multiline
                rows={2}
                inputProps={{ maxLength: 255 }}
                size="small"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="เลขที่บัญชี"
                value={accountNumber}
                onChange={handleAccountNumberChange}
                fullWidth
                error={errors.accountNumber}
                helperText={
                  errors.accountNumber ? 'กรุณากรอกเลขที่บัญชีให้ถูกต้อง' : ''
                }
                inputProps={{
                  maxLength: bank === 'GSB' ? 12 : bank === 'BAAC' ? 13 : 10,
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                }}
                size="small"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ marginBottom: '20px', marginRight: '20px' }}>
        <Button
          onClick={onClose}
          sx={{
            width: '100px',
            border: '1px solid',
            color: '#FC3A3A',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(252, 58, 58, 0.1)',
            },
          }}
        >
          ยกเลิก
        </Button>
        <Button
          onClick={handleSave}
          sx={{
            width: '100px',
            border: '1px solid',
            color: '#51D245',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(81, 210, 69, 0.1)',
            },
          }}
        >
          บันทึก
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BankAccountPopup;
